<template>
  <v-tooltip v-if="hasRetentionInfo" location="bottom" :aria-label="formatRetentionTooltip">
    <template v-slot:activator="{ props }">
      <v-icon
        v-bind="props"
        icon="mdi-delete-clock"
        size="small"
        class="retention-icon pb-1 pr-1"
      />
    </template>
    <div class="retention-tooltip">
      {{ formatRetentionTooltip }}
    </div>
  </v-tooltip>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'RecycleBinGridViewRetentionPeriod',
  props: {
    pod: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasRetentionInfo() {
      return this.pod?.retention && this.pod.retention.startedAt && this.pod.retention.period && this.pod.retention.periodType;
    },

    retentionStartDate() {
      if (!this.pod?.retention?.startedAt) return null;
      return new Date(this.pod.retention.startedAt);
    },

    retentionPeriod() {
      return this.pod?.retention?.period || 0;
    },

    retentionPeriodType() {
      return this.pod?.retention?.periodType || 'HOURS';
    },

    formatRetentionTooltip() {
      if (!this.hasRetentionInfo) return '';

      const period = this.retentionPeriod;
      const type = this.retentionPeriodType.toLowerCase();
      const startDate = format(this.retentionStartDate, 'MMM dd, yyyy HH:mm');

      const periodText = this.$t(`common.time.${type}`, period);

      return `${this.$t('routes.recycleBin.deletedDueToRetentionPolicy')} (${periodText} ${this.$t('routes.recycleBin.retentionPeriod')} - ${this.$t('routes.recycleBin.startedOn')} ${startDate})`;
    },
  },
};
</script>

<style scoped>
.retention-icon {
  opacity: 0.7;
}

.retention-icon:hover {
  opacity: 1;
}

.retention-tooltip {
  font-size: 0.875rem;
  max-width: 300px;
  white-space: normal;
  line-height: 1.4;
}
</style>
